import { useCallback, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootState, useAppSelector } from '../store';
import { getBreakpoint } from '../utils/breakpoint';

const useGroups = () => {
    const navigate = useNavigate();
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const settings = useAppSelector((state: RootState) => state.settings);
    const windowWidth = useAppSelector((state: RootState) => state.environment.windowWidth);
    const searchInput = useRef<HTMLInputElement>(null);

    const handleEdit = useCallback(
        (identifier: string) => {
            navigate(identifier);
        },
        [navigate],
    );

    const GroupsActions = useMemo(
        () => ({
            handleEdit,
        }),
        [handleEdit],
    );

    const handleNavigate = useCallback(
        (path: string) => {
            navigate(path);
        },
        [navigate],
    );

    return {
        GroupsActions,
        settings,
        i18n,
        searchInput,
        windowWidth,
        getBreakpoint,
        handleNavigate,
    };
};

export default useGroups;
